var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header'),_c('AppMain',{staticClass:"layout_appmain"}),(this.$route.path != '/home')?_c('Footer'):_vm._e(),_c('img',{staticClass:"kefu",attrs:{"src":require("../../src/assets/officialImg.png"),"alt":""},on:{"click":_vm.windowClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }